/**************************************************************************
Name:         carousel.js
Description:  Scripting for news carousel
Date Created: 12.04.2019 by Brynn Chivers
**************************************************************************/

function initSwiper (new_swiper, containerClass, paginationClass, changeEffect, autoPlay) {
	new_swiper = new Swiper(containerClass, {
		speed: 400,
		watchOverflow: true,
		loop: true,
		effect: changeEffect,
		pagination: {
			el: paginationClass,
			type: 'bullets',
			clickable: true,
			hideOnClick: false
		},
		autoplay: autoPlay
	});

	return new_swiper;
}